import { call, put, takeEvery } from "redux-saga/effects"
import { toast } from "react-toastify";

import { CREATE_CLIENT_APPOINTMENT, DELETE_CLIENT_APPOINTMENT, GET_CLIENTS_APPOINTMENT, UPDATE_CLIENT_APPOINTMENT } from "./actionTypes"

import { deleteClientAppointmentAPI, getClientAppointment, postClientAppointment, updateClientAppointmentAPI } from '../../helpers/backend_helper'

import { addClientAppointmentFail, addClientAppointmentSuccess, deleteClientAppointmentFail, deleteClientAppointmentSuccess, getClientAppointmentFail, getClientAppointmentSuccess, updateClientAppointmentError } from "./actions"
import { take } from "lodash";
import moment from "moment";

function* submitClientAppointment({ payload: { appointment, history, callback } }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(postClientAppointment, {
      appointmentTitle: appointment.appointmentTitle,
      contactName: appointment.contactName,
      contactPhone: appointment.contactPhone,
      contactEmail: appointment.contactEmail,
      appointmentStartDate: moment(appointment.appointmentStartDate).format('YYYY-MM-DD'),
      startTime: appointment.startTime,
      endTime: appointment.endTime,
      appointmentType: parseInt(appointment.appointmentType) || 0,
      appointmentPriority: parseInt(appointment.appointmentPriority) || 0,
      appointmentLocationType:parseInt(appointment.appointmentLocationType) || 0,
      appointmentLocation:appointment.appointmentLocation,
      appointmentDescription: appointment.appointmentDescription,
      clientId: parseInt(appointment.clientId),
      agentId: parseInt(appointment.agentId),
      addedBy: 'client'
      

    })
    yield put(addClientAppointmentSuccess(response))
    if (response.success == true) {
      toast.dismiss();
      toast.success("Appointement Added");
      const response = yield call(getClientAppointment,  appointment.agentId, appointment.clientId )
    yield put(getClientAppointmentSuccess(response))
      if (callback) callback(true);
    } else {
      toast.dismiss();
      toast.warn("Some Error. Please try after some time");
      if (callback) callback(false);
    }
  }
  catch (error) {
    toast.dismiss();
    yield put(addClientAppointmentFail(error))
    if (callback) callback(false);
  }
}

function* onDeleteClientAppointment({ payload: appointment }) {
  //console.log(document);
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteClientAppointmentAPI, appointment.id)
    yield put(deleteClientAppointmentSuccess(response))
    toast.dismiss();
    toast.success("Appointement Deleted");
    const res = yield call(getClientAppointment, appointment.agentId, appointment.clientId)
    yield put(getClientAppointmentSuccess(res))
  } catch (error) {
    yield put(deleteClientAppointmentFail(error))
  }
}

function* fetchClientAppointment({ payload: { agentId, clientId }  }) {
  try {
    const response = yield call(getClientAppointment,  agentId, clientId )
    yield put(getClientAppointmentSuccess(response))
  } catch (error) {
    yield put(getClientAppointmentFail(error))
  }
}

// function* onClientAppointmentUpdate({ payload: appointment, callback }) {
//   try {
//     toast.loading("Please wait...")
//     const response = yield call(updateClientAppointmentAPI, appointment)
//     toast.dismiss();
//     toast.success("Appointement Updated");
//     const res = yield call(getClientAppointment, appointment.agentId, appointment.clientId)
//     yield put(getClientAppointmentSuccess(res))
//     //yield put(updateClientAppointmentSuccess(response))
//   } catch (error) {
//     yield put(updateClientAppointmentError(error))
//   }
// }

function* onClientAppointmentUpdate({ payload: { appointment, callback } }) {
  let toastId;
  try {
    toastId = toast.loading("Please wait...");

    const response = yield call(updateClientAppointmentAPI, appointment);

    if (response?.success) {
      toast.update(toastId, {
        render: "Updated successfully",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      const res = yield call(
        getClientAppointment,
        appointment.agentId,
        appointment.clientId
      );
      yield put(getClientAppointmentSuccess(res));
      if (callback) callback(true);
    } else {
      toast.update(toastId, {
        render: response.validationErrors?.[0] || "Something went wrong",
        type: "warning",
        isLoading: false,
        autoClose: 4000,
      });

      if (callback) callback(false);
    }
  } catch (error) {
    toast.update(toastId, {
      render: error.response?.data?.message || "Failed to update appointment",
      type: "error",
      isLoading: false,
      autoClose: 4000,
    });

    yield put(updateClientAppointmentError(error));

    if (callback) callback(false, error);
  }
}







function* appointmentaga() {
  
  yield takeEvery(CREATE_CLIENT_APPOINTMENT, submitClientAppointment)
  yield takeEvery(GET_CLIENTS_APPOINTMENT, fetchClientAppointment)
  yield takeEvery(DELETE_CLIENT_APPOINTMENT, onDeleteClientAppointment)
  yield takeEvery(UPDATE_CLIENT_APPOINTMENT, onClientAppointmentUpdate)

}


export default appointmentaga
